// src/ride/RideSidebar.js
import React from "react";
import { NavLink } from "react-router-dom";
import { Car, ClipboardList, MessageSquare, ArrowLeftCircle } from "lucide-react";

const RideSidebar = () => {
  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 px-3 py-2 rounded-lg font-medium transition-all duration-200 ${
      isActive
        ? "bg-blue-100 text-blue-700 shadow-sm"
        : "text-gray-800 hover:bg-blue-50 hover:text-blue-600"
    }`;

  return (
    <div className="hidden md:flex flex-col w-64 min-h-screen bg-white border-r border-gray-200 p-6 shadow-sm">
      
      {/* Header */}
      <div className="text-2xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600 mb-8">
        BYN Rides
      </div>

      {/* Navigation */}
      <nav className="flex flex-col space-y-2 text-sm">

        <NavLink to="/ride/post" className={linkClass}>
          <Car className="w-5 h-5" />
          Post a Ride
        </NavLink>

        <NavLink to="/ride/my-rides" className={linkClass}>
          <ClipboardList className="w-5 h-5" />
          My Rides
        </NavLink>

        {/* NEW — Requests Hub */}
        <NavLink to="/ride/requests" className={linkClass}>
          <MessageSquare className="w-5 h-5" />
          Ride Requests
        </NavLink>

        <div className="border-t my-3"></div>

        <NavLink to="/dashboard" className={linkClass}>
          <ArrowLeftCircle className="w-5 h-5" />
          Back to Worker Dashboard
        </NavLink>

      </nav>
    </div>
  );
};

export default RideSidebar;
